function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/* eslint-disable no-underscore-dangle */


import { cmpLog, LOG_TYPE_EXTENDED, LOG_TYPE_ERROR, REJECTED_BY_PURPOSES, NO_VENDOR_FOUND, FAILED, SUCCESS, CROSS_CHECK_VENDOR, CROSS_CHECK_VENDOR_FAILED } from './logger';

var getVendor = function getVendor(id) {
  return window.consents.vendorsList[id];
};

export var getRealConsent = function getRealConsent(id) {
  return window.consents.filteredVendors.includes(id);
};
export var getConsent = function getConsent(id) {
  var vendor = window.consents.vendorsList[id] && window.consents.vendorsList[id].name;

  if (vendor) {
    var vendorConsent = window.consents.vendors.includes(id);
    var crossedConsent = getRealConsent(id);
    return {
      vendor: vendor,
      consent: crossedConsent,
      restrictions: vendorConsent && !crossedConsent ? "".concat(vendor.toUpperCase(), " ").concat(REJECTED_BY_PURPOSES) : null
    };
  }

  return "".concat(NO_VENDOR_FOUND, " ").concat(id);
};

var searchVendor = function searchVendor(string) {
  var vendors = Object.values(window.consents.vendorsList).filter(function (vendor) {
    return vendor.name.toLowerCase().includes(string.toLowerCase());
  });
  return vendors;
}; // Returns consent crossing the consent information from the Vendor and Purposes
// Consent is considered rejected for a vendor if ANY of its declared purposes is not accepted


export var checkVendorPurposes = function checkVendorPurposes(id) {
  return new Promise(function (resolve, reject) {
    if (Object.keys(window.consents.vendorsList).length > 0 && getVendor(id)) {
      window.__tcfapi('getVendorConsent', 2, function (vendorConsent, success) {
        cmpLog(LOG_TYPE_EXTENDED, "".concat(CROSS_CHECK_VENDOR, " [").concat(id, "]"), getVendor(id).name, success ? SUCCESS : FAILED, vendorConsent);

        if (success) {
          resolve(vendorConsent);
        } else {
          cmpLog(LOG_TYPE_ERROR, "".concat(CROSS_CHECK_VENDOR_FAILED, " ").concat(id));
          reject();
        }
      }, id);
    }

    reject();
  });
};
export var saveConsentValue = function saveConsentValue(vendorName, vendorValue) {
  localStorage.setItem(vendorName, vendorValue);
};
export var CONSENTS_INTERFACE = {
  chartbeat: false,
  vendors: null,
  filteredVendors: null,
  purposes: null,
  tcString: null,
  googleIds: null,
  comscore: false,
  google: {
    advertising: false,
    associatedTechnologies: false,
    associatedIds: null
  },
  dmp: false,
  vendorsList: {},
  purposesList: {},
  getVendor: getVendor,
  getConsent: getConsent,
  searchVendor: searchVendor,
  checkVendorPurposes: checkVendorPurposes,
  saveConsentValue: saveConsentValue
};
export var checkConsents = function checkConsents(tcData) {
  window.__tcfapi('getOtherVendorConsents', 2, function (otherVendorConsents, success) {
    if (success) {
      var consents = [].concat(_toConsumableArray(Object.values(tcData.publisher.consents)), _toConsumableArray(Object.values(tcData.publisher.customPurpose.consents)), _toConsumableArray(Object.values(tcData.purpose.consents)), _toConsumableArray(Object.values(tcData.purpose.legitimateInterests).slice(1, tcData.purpose.legitimateInterests.length)), _toConsumableArray(Object.values(tcData.specialFeatureOptins)), _toConsumableArray(Object.values(otherVendorConsents)));
      var purposeAccepted = consents.every(function (cons) {
        return +cons;
      });
      var purposeRejected = consents.every(function (cons) {
        return !+cons;
      });
      window.consents = _objectSpread(_objectSpread({}, window.consents), {}, {
        purposeAccepted: purposeAccepted,
        purposeRejected: purposeRejected
      });
    } else {
      console.error('Error: could not get otherVendorConsents');
    }
  });
};